import { render, staticRenderFns } from "./TouchpointStatisticsTraffic.vue?vue&type=template&id=4d431e54&scoped=true&"
import script from "./TouchpointStatisticsTraffic.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsTraffic.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointStatisticsTraffic.vue?vue&type=style&index=0&id=4d431e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d431e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d431e54')) {
      api.createRecord('4d431e54', component.options)
    } else {
      api.reload('4d431e54', component.options)
    }
    module.hot.accept("./TouchpointStatisticsTraffic.vue?vue&type=template&id=4d431e54&scoped=true&", function () {
      api.rerender('4d431e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatisticsTraffic.vue"
export default component.exports